/**
 * 错误日志接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LogErrorService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 错误日志接口
  /**
   * 查询错误日志所有信息
   * @param param
   * @returns {Observable<any>}
   */
  getLogErrorList(param) {
    const url = this.prefix + 'errorLog/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 查询错误日志所有信息
   * @param param
   * @returns {Observable<any>}
   */
  exportErrorLogList(param) {
    const url = this.prefix + 'errorLog/export';
    let headers = this.http.SetHeader();
    return this.httpClient.post(url, param, { responseType: 'blob', observe: 'response', headers: headers });
  }
 

  //#endregion


}
